//! Deprecate: Este componente sigue existiendo por si el redireccionamiento //
//! falla pero el componente correcto es "DeveloperLeads"
<template>
  <div id="admin-lead-view" class="lead-view">
    <v-row no-gutters>
      <v-col md="12">
        <lead-table />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";

export default {
  components: {
    LeadTable: () => import("@/components/lead/LeadTable.vue")
  },
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  }
};
</script>
